import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'projects/lib_config/src/public-api';
import { Observable } from 'rxjs';
import { EFileStatusCount } from '../models/efile-status-count.model';

@Injectable({
  providedIn: 'root'
})
export class EfileService {

  constructor(private http: HttpClient, private settings: ApplicationSettings) {
  }

  getEFileStatussesCount(eFileStatusses: string[], eFileSubmissionStatusses: string[]): Observable<EFileStatusCount[]> {
    return this.http.post<EFileStatusCount[]>(this.settings.backendUrlReporting + `/efile/statussesCount`,  { efileStatusCodes: eFileStatusses, efileSubmissionStatusCodes: eFileSubmissionStatusses});
  }
}